/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _, { update } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import metadata from './DiscountSurchargesLossAccordion.metadata.json5';
import styles from './DiscountSurchargesLossAccordion.module.scss'


const DiscountSurchargesLossAccordion = props => {
    const {
        roofAndRepairs, lobData_TWIA, policyDetailsData
    } = props;

    const getDateCell = useCallback((item, index, property) => moment(item[property.id]).format('MM/DD/YYYY'), []);


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {           
            className:styles.fieldStyle
        },
        priorLossesListTable: {
            data: _.get(policyDetailsData, 'priorLosses')
        },
        homeSecurityDevice: {
            value: _.get(policyDetailsData, 'lobs.homeOwners_tfpa.dwellingDTO.dwellingHomeSecurityDeviceCredit_Ext') ? 'Yes' : 'No'
        }
    };


    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getDateCell
        }
    };


    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={policyDetailsData}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        // componentMap={resolvers.resolveComponentMap}
        />
    );
};


DiscountSurchargesLossAccordion.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({})
};
export default DiscountSurchargesLossAccordion;
